export enum EStatusRequisicaoAutorizacao {
  Pendente = 1,
  Autorizada = 2,
  Negada = 3,
  Expirada = 4,
}
